import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "rowcenter" }

import svgBody from '@/items/svgBody.vue'

import { computed, watch } from 'vue'
import { useCurrentEntryStore } from '@/stores/currentEntry'
import { useAppUserStore } from '@/stores/appUser'


export default /*@__PURE__*/_defineComponent({
  __name: 'resultSuggestionsUpper',
  setup(__props) {

const currentEntryStore = useCurrentEntryStore()
const appUserStore = useAppUserStore()

const bodyParts = computed(() => {
  return currentEntryStore.bodyParts
})

function humanBodyFCT(bodyPart) {
  currentEntryStore.switchBodyPart(bodyPart)
}

function changedCclForResult() {
  currentEntryStore.clearActiveResultSuggestion()
}

const suggestionsShowHumanBody = computed(() => {
  return appUserStore.currentAppUserData?.preferences?.suggestionsShowHumanBody ?? true
})

watch(
  () => currentEntryStore.currentCcl,
  () => {
    changedCclForResult()
  },
  { immediate: true }
)


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (suggestionsShowHumanBody.value)
      ? (_openBlock(), _createBlock(svgBody, {
          key: 0,
          active: bodyParts.value,
          onClick: humanBodyFCT
        }, null, 8, ["active"]))
      : _createCommentVNode("", true)
  ]))
}
}

})